export enum ElementID {
  Settings = 'settings',
  ReactRoot = 'react-root',
}
